import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import ItemList from 'flarum/common/utils/ItemList';
import listItems from 'flarum/common/helpers/listItems';
import extractText from 'flarum/common/utils/extractText';
import Button from 'flarum/common/components/Button';
import Dropdown from 'flarum/common/components/Dropdown';
import PollList from './Poll/PollList';
import PollListState from '../states/PollListState';
import PollPageHero from './PollPageHero';
import PollsIndexSidebar from './PollsIndexSidebar';
const STATUS_FILTER_VALUE = {
  all: 'any',
  published: '0',
  draft: '1'
};

/**
 * Reverse lookup: `filter[isDraft]` URL value → status dropdown key. Anything
 * else (including missing) falls back to "all", matching the server-side
 * default in PollsDirectory.
 */
function statusFromUrl() {
  const raw = new URLSearchParams(window.location.search).get('filter[isDraft]');
  if (raw === '1' || raw === 'true') return 'draft';
  if (raw === '0' || raw === 'false') return 'published';
  return 'all';
}
export default class PollsPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", void 0);
    _defineProperty(this, "status", 'all');
  }
  oninit(vnode) {
    super.oninit(vnode);
    if (!app.forum.attribute('globalPollsEnabled')) {
      m.route.set('/');
      return;
    }
    const defaultSort = String(app.forum.attribute('pollsDirectoryDefaultSort')) || 'newest';

    // Keep the dropdown label honest when landing via a share link like
    // /polls/all?filter[isDraft]=1 — otherwise the UI would read "All" while
    // the list is actually drafts-only.
    this.status = statusFromUrl();
    this.state = new PollListState({
      sort: defaultSort,
      filter: {
        isDraft: STATUS_FILTER_VALUE[this.status]
      }
    });
    this.state.refresh();
    app.setTitle(extractText(app.translator.trans('fof-polls.forum.page.nav')));
  }
  setStatus(status) {
    if (this.status === status) return;
    this.status = status;
    const params = this.state.getParams();
    this.state.refreshParams(_objectSpread(_objectSpread({}, params), {}, {
      filter: _objectSpread(_objectSpread({}, params.filter || {}), {}, {
        isDraft: STATUS_FILTER_VALUE[status]
      })
    }), 1);
  }
  view() {
    return m(PageStructure, {
      className: "PollsPage",
      hero: this.hero.bind(this),
      sidebar: this.sidebar.bind(this),
      loading: !this.state
    }, this.contentItems().toArray());
  }
  hero() {
    return m(PollPageHero, null);
  }
  sidebar() {
    return m(PollsIndexSidebar, null);
  }
  contentItems() {
    const items = new ItemList();
    items.add('toolbar', m("div", {
      className: "IndexPage-toolbar"
    }, this.toolbarItems().toArray()), 100);
    items.add('pollList', m(PollList, {
      state: this.state
    }), 10);
    return items;
  }
  toolbarItems() {
    const items = new ItemList();
    items.add('view', m("ul", {
      className: "IndexPage-toolbar-view"
    }, listItems(this.viewItems().toArray())), 100);
    items.add('action', m("ul", {
      className: "IndexPage-toolbar-action"
    }, listItems(this.actionItems().toArray())), 10);
    return items;
  }
  viewItems() {
    const items = new ItemList();
    const sortMap = this.state.sortMap();
    const currentSortKey = Object.keys(sortMap).find(key => sortMap[key] === this.state.getSort()) || String(app.forum.attribute('pollsDirectoryDefaultSort')) || 'newest';
    const sortOptions = Object.keys(sortMap).reduce((acc, sortId) => {
      acc[sortId] = extractText(app.translator.trans("fof-polls.forum.polls_list.sort_dropdown.".concat(sortId)));
      return acc;
    }, {});
    const statusKeys = ['all', 'published', 'draft'];
    const statusLabels = {
      all: app.translator.trans('fof-polls.forum.polls_list.status_filter.all'),
      published: app.translator.trans('fof-polls.forum.polls_list.status_filter.published'),
      draft: app.translator.trans('fof-polls.forum.polls_list.status_filter.draft')
    };
    items.add('status', m(Dropdown, {
      buttonClassName: "Button",
      label: statusLabels[this.status]
    }, statusKeys.map(key => {
      const active = this.status === key;
      return m(Button, {
        icon: active ? 'fas fa-check' : true,
        active: active,
        onclick: () => this.setStatus(key)
      }, statusLabels[key]);
    })), 10);
    items.add('sort', m(Dropdown, {
      buttonClassName: "Button",
      label: sortOptions[currentSortKey] || app.translator.trans('fof-polls.forum.polls_list.sort_dropdown.default')
    }, Object.keys(sortOptions).map(value => m(Button, {
      icon: currentSortKey === value ? 'fas fa-check' : true,
      onclick: () => this.state.setSort(sortMap[value]),
      active: currentSortKey === value
    }, sortOptions[value]))), 0);
    return items;
  }
  actionItems() {
    const items = new ItemList();
    items.add('refresh', m(Button, {
      "aria-label": extractText(app.translator.trans('core.forum.index.refresh_tooltip')),
      icon: "fas fa-sync",
      className: "Button Button--icon",
      onclick: () => this.state.refresh()
    }));
    return items;
  }
}
flarum.reg.add('fof-polls', 'forum/components/PollsPage', PollsPage);